// extracted by mini-css-extract-plugin
module.exports = {"StatusBox":"RefundStatus__StatusBox__Jy62a","FakeStatusBox":"RefundStatus__FakeStatusBox__1kLBW","Gradient":"RefundStatus__Gradient__3m6Hi"};